<template>
  <div class="checkout-summary summary-list">
    <div class="summary-item">
      <div v-apply-theme :class="[
        'valor-total',
        { skeleton: loading }
      ]">
       {{ downPaymentPercentage | downPaymentText }}
      </div>
      <div
        :class="[
          ('valor-total__valor'),
          { skeleton: loading }
        ]"
        v-apply-theme
      >
        {{ downPaymentValue || 0 | moneyFilter }}
      </div>
    </div>
    <div class="line"></div>
    <div class="summary-item">
      <div v-apply-theme :class="'valor-total'">
        Valor total
      </div>
      <div v-apply-theme :class="[
        'valor-total__valor',
        { skeleton: loading && moneyFilter(totalAmount) }
      ]">
        {{ moneyFilter(totalAmount) || '-' }}
      </div>
    </div>
    <div class="summary-footer-info" v-if="cetPA && interestRatePM">
      <div class="summary-footer-info-content" :class="{ skeleton: loading }">
        {{ interestText }}
      </div>
      <div class="summary-footer-info-content" :class="{ skeleton: loading }">
        {{ maxCetText }}
      </div>
    </div>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import { ApplyTheme } from '@/directives/applyTheme';
import CheckoutMixin from '../checkout.mixin';

export default {
  name: 'checkout-summary',
  methods: { },
  mixins: [StringMixin, CheckoutMixin],
  directives: {
    ApplyTheme,
  },
  computed: {
    interestText() {
      return `Juros de ${this.interestRateFilter(this.interestRatePM)} a.m. + Encargos.`;
    },
    maxCetText() {
      return `CET máximo de ${this.interestRateFilter(this.cetPA)} a.a.`;
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    downPaymentValue: {
      type: Number,
    },
    downPaymentPercentage: {
      type: Number,
    },
    totalAmount: {
      type: Number,
    },
    interestRatePM: {
      type: Number,
    },
    cetPA: {
      type: Number,
    },
    oneLineFooter: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
.summary-list {
  background-color: var(--gray-100);
  border-radius: 4px;
}

.summary-item {
  padding: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.line {
  height: 0px;
  border-bottom: 1px solid var(--gray-300);
  margin: 0 12px;
}

.summary-footer-info {
  display: flex;
  padding: 0 12px 12px;
  font-size: 12px;
  line-height: 18px;
  color: var(--gray-400);
}

.summary-footer-info-content:first-child {
  margin-bottom: 4px;
  margin-right: 8px;
}

.valor-total {
  @extend .body-regular;

  &--vivo {
    font-weight: 200 !important;
    letter-spacing: -0.5px;
  }

  &__valor {
    @extend .body-bold;

    &--vivo {
      letter-spacing: -0.5px;
    }
  }
}

</style>
